<div class="flex items-center"></div>

<div class="flex flex-col w-full">
  @if (unitEntryResource.isLoading()) {
  <div class="h-20 w-full skeleton min-w-full select-none"></div>
  } @else {
  <soft-mengen-eingabe
    class="w-full -mt-1"
    [value]="inputAmount()?.quantity ?? quantity() ?? 1"
    [inputClass]="''"
    [float]="true"
    [disabled]="quantityInputDisabled()"
    (valueChange)="onQuantityChange($event)"
    [einheit]="inputAmount()?.unit?.arteh || undefined"
    [preventKeyboardEventEmission]="true"
  />
  }

  <!-- Unit Entry details -->
  @if (unitEntryEnabled()) {
  <div class="flex items-center justify-evenly">
    <div class="flex flex-col gap-2">
      <span class="text-sm inline-block whitespace-nowrap text-light shrink-0 mt-2">
        = {{ amount().quantity | number: '1.0-3' }} {{ amount()?.unit?.arteh }}
      </span>
    </div>

    @if (strategy().enabled()) {
    <div class="flex items-center w-full justify-end text-right mt-1.5">
      <button class="soft-button link !p-0" (click)="openUnitEntryModal()">
        Mengeneingabe
      </button>
    </div>
    }
  </div>
  }
</div>
